<template>
  <bm-unit-base
    v-bind="$attrs"
    :value="value"
    :unit-preference="unitPreference"
    @update:value="emit('update:value', $event)"
  />
</template>

<script setup lang="ts">
import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import BmUnitBase from "@/components/controls/input/specialised/BmUnitBase.vue";

interface BmVolumeGeneralProps {
  value?: number | null;
}

interface BmVolumeGeneralEvents {
  (event: "update:value", value: number | null): void;
}

withDefaults(defineProps<BmVolumeGeneralProps>(), {
  value: null,
});

const emit = defineEmits<BmVolumeGeneralEvents>();

const unitPreference =
  tenantService.settings.displayUnitPreferences.generalVolumes;
</script>
